import React from "react";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import PhoneLink from "components/elements/phone-link";
import TextContent from "components/elements/text-content";

const TermsOfUse = () => (
  <Layout className="terms-of-use" title="Terms of use">
    <Header>
      <HeaderBanner
        title="Terms of use"
        icon="faq"
        background="/static/images/header-balcony.jpg"
      />
    </Header>
    <Breadcrumbs>
      <Breadcrumbs.Item title="Terms of use" url="terms-of-use" />
    </Breadcrumbs>
    <div className="container">
      <TextContent>
        PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS SITE
        <ol>
          <li>
            <strong>TERMS OF WEBSITE USE (v.1)</strong>
            <ol>
              <li>
                These terms of use (together with the documents referred to
                below) tells you the terms of use on which you may make use of
                Our website (http://hammerpricehomes.co.uk) (Our Site), whether
                as a guest or a registered user. Use of Our Site includes
                accessing, browsing, or registering to use Our Site.
              </li>
              <li>
                Please read these terms of use carefully before you start to use
                Our Site, as these will apply to your use of Our Site. We
                recommend that you print a copy of this for future reference.
              </li>
              <li>
                By using Our Site, you confirm that you accept these terms of
                use and that you agree to comply with them.
              </li>
              <li>
                If you do not agree to these terms of use, you must not use Our
                Site.
              </li>
            </ol>
          </li>
          <li>
            <strong>OTHER APPLICABLE TERMS</strong>
            <ol>
              <li>
                These terms of use refer to the following additional terms,
                which also apply to your use of Our Site:
              </li>
              <li>
                Our <a href="/privacy-policy/">Privacy Policy</a>, which sets
                out the terms on which We process any personal data We collect
                from you, or that you provide to Us. By using Our Site, you
                consent to such processing and you warrant that all data
                provided by you is accurate.
              </li>
              <li>
                Our <a href="/privacy-policy#cookie-policy">Cookie Policy</a>,
                which sets out information about the cookies on Our Site.
              </li>
              <li>
                If you register for Our Site (a <strong>Registered User</strong>
                ) additional terms and conditions (
                <strong>Additional Terms</strong>) will apply depending on
                whether you register as a{" "}
                <a href="/terms-and-conditions/">Seller</a> or as a{" "}
                <a href="/terms-and-conditions/">Buyer</a>.
              </li>
            </ol>
          </li>
          <li>
            <strong>INFORMATION ABOUT US</strong>
            <ol>
              <li>
                http://www.hammerpricehomes.co.uk is a website operated by
                Hammer Price Homes Limited (<strong>We</strong> or{" "}
                <strong>Us</strong>). We are a limited company registered in
                England and Wales under company number 08819923 and have Our
                registered office at 23 New Mount Street, Manchester M4 4DE.
              </li>
            </ol>
          </li>
          <li>
            <strong>CHANGES TO THESE TERMS</strong>
            <ol>
              <li>
                We may revise these terms of use at any time by amending this
                page.
              </li>
              <li>
                Please check this page from time to time to take notice of any
                changes We make, as they are binding on you.
              </li>
            </ol>
          </li>
          <li>
            <strong>CHANGES TO OUR SITE</strong>
            <ol>
              <li>
                We may update Our Site from time to time, and may change the
                content at any time. However, please note that any of the
                content on Our Site may be out of date at any given time, and We
                are under no obligation to update it.
              </li>
              <li>
                We do not guarantee that Our Site, or any content on it, will be
                free from errors or omissions.
              </li>
            </ol>
          </li>
          <li>
            <strong>ACCESSING OUR SITE</strong>
            <ol>
              <li>
                Our site is a marketing site made available to the general
                public free of charge. There are areas of Our Site that can only
                be accessed if you have formally registered with Us and have
                accepted the applicable Additional Terms.
              </li>
              <li>
                We do not guarantee that Our Site, or any content on it, will
                always be available or be uninterrupted. Access to Our Site is
                permitted on a temporary basis. We may suspend, withdraw,
                discontinue or change all or any part of Our Site without
                notice. We will not be liable to you if for any reason Our Site
                is unavailable at any time or for any period.
              </li>
              <li>
                You are responsible for making all arrangements necessary for
                you to have access to Our Site.
              </li>
              <li>
                You are also responsible for ensuring that all persons who
                access Our Site through your internet connection are aware of
                these terms of use and other applicable terms and conditions,
                and that they comply with them.
              </li>
              <li>
                Our site is directed to people residing in the United Kingdom.
                We do not represent that content available on or through Our
                Site is appropriate or available in other locations. We may
                limit the availability of Our Site or any service or product
                described on Our Site to any person or geographic area at any
                time. In particular, We only accept Listings (as defined in Our
                Sellers Terms) for Property located in England and Wales). If
                you choose to access Our Site from outside the United Kingdom,
                you do so at your own risk.
              </li>
              <li>
                You agree not to do any of the following:
                <ul>
                  <li>
                    attempt to gain or gain any form of unauthorised access to
                    Our Site which includes damage or disruption to it or the
                    server on which it is stored or the same to any related
                    computer system or data storage /retrieval system and/or any
                    software used in the service of it. You agree not to attack
                    Our Site with the use of any kind of rogue computer
                    programme or virus or further attack the site with a denial
                    of service or distributed denial of service;
                  </li>
                  <li>
                    interfere with, damage or disrupt any equipment or network
                    or software owned or used by any third party in connection
                    with Our Site;
                  </li>
                  <li>
                    attempt to by-pass for any reason the security safeguards
                    that are contained within Our Site;
                  </li>
                  <li>
                    transmit any email or other form of electronic communication
                    which has as its intention disruption of Our Site and any
                    and all related computer functions or permit your
                    representative or a third party to do this; and/or
                  </li>
                  <li>
                    encourage permit or otherwise enable a third party to do any
                    of the above.
                  </li>
                </ul>
              </li>
            </ol>
          </li>
          <li>
            <strong>INTELLECTUAL PROPERTY RIGHTS</strong>
            <ol>
              <li>
                We are the owner or the licensee of all intellectual property
                rights in Our Site, and in the material published on it. Those
                works are protected by copyright laws and treaties around the
                world. All such rights are reserved.
              </li>
              <li>
                You may print off one copy, and may download extracts, of any
                page(s) from Our Site for your personal use and you may draw the
                attention of others to content posted on Our Site.
              </li>
              <li>
                You must not modify the paper or digital copies of any materials
                you have printed off or downloaded in any way, and you must not
                use any illustrations, photographs, video or audio sequences or
                any graphics separately from any accompanying text.
              </li>
              <li>
                Our status (and that of any identified contributors) as the
                authors of content on Our Site must always be acknowledged.
              </li>
              <li>
                You must not use any part of the content on Our Site for
                commercial purposes without obtaining a licence to do so from Us
                or Our licensors.
              </li>
              <li>
                If you print off, copy or download any part of Our Site in
                breach of these terms of use, your right to use Our Site will
                cease immediately and you must, at Our option, return or destroy
                any copies of the materials you have made.
              </li>
            </ol>
          </li>
          <li>
            <strong>NO RELIANCE ON INFORMATION</strong>
            <ol>
              <li>
                The content on Our Site is provided for general information
                only. It is not intended to amount to advice on which you should
                rely. You must obtain professional or specialist advice before
                taking, or refraining from, any action on the basis of the
                content on Our Site.
              </li>
              <li>
                Although We make reasonable efforts to update the information on
                Our Site, We make no representations, warranties or guarantees,
                whether express or implied, that the content on Our Site is
                accurate, complete or up-to-date.
              </li>
            </ol>
          </li>
          <li>
            <strong>LIMITATION OF OUR LIABILITY</strong>
            <ol>
              <li>
                Nothing in these terms of use excludes or limits Our liability
                for death or personal injury arising from Our negligence, or Our
                fraud or fraudulent misrepresentation, or any other liability
                that cannot be excluded or limited by English law.
              </li>
              <li>
                To the extent permitted by law, We exclude all conditions,
                warranties, representations or other terms which may apply to
                Our Site or any content on it, whether express or implied.
              </li>
              <li>
                We will not be liable to any user for any loss or damage,
                whether in contract, misrepresentation, tort (including
                negligence), breach of statutory duty, or otherwise, even if
                foreseeable, arising under or in connection with:
                <ul>
                  <li>use of, or inability to use, Our Site; or</li>
                  <li>
                    use of or reliance on any content displayed on Our Site.
                  </li>
                </ul>
                If you are a business user, please note that in particular, We
                will not be liable for:
                <ul>
                  <li>loss of profits, sales, business, or revenue;</li>
                  <li>business interruption;</li>
                  <li>loss of anticipated savings;</li>
                  <li>
                    loss of business opportunity, goodwill or reputation; or
                  </li>
                  <li>any indirect or consequential loss or damage.</li>
                </ul>
              </li>
              <li>
                If you are a consumer user, please note that We only provide Our
                Site for domestic and private use. You agree not to use Our Site
                for any commercial or business purposes, and We have no
                liability to you for any loss of profit, loss of business,
                business interruption, or loss of business opportunity.
              </li>
              <li>
                We will not be liable for any loss or damage caused by a virus,
                distributed denial-of-service attack, or other technologically
                harmful material that may infect your computer equipment,
                computer programs, data or other proprietary material due to
                your use of Our Site or to your downloading of any content on
                it, or on any website linked to it.
              </li>
              <li>
                We assume no responsibility for the content of websites linked
                on Our Site. Such links should not be interpreted as endorsement
                by Us of those linked websites. We will not be liable for any
                loss or damage that may arise from your use of them.
              </li>
              <li>
                Subject to clauses 9.1 to 9.6 (as applicable) above, the extent
                of Our liability to you or any third party whether for breach of
                contract, misrepresentation, tort (including negligence), breach
                of statutory duty arising out of or in connection with these
                Terms of Website Use shall be limited to £500.
              </li>
              <li>
                Additional limitations and exclusions of liability will apply to
                Registered Users, which will be set out in Our{" "}
                <a href="/terms-and-conditions/">Additional Terms</a>.
              </li>
            </ol>
          </li>
          <li>
            <strong>VIRUSES</strong>
            <ol>
              <li>
                We do not guarantee that Our Site will be secure or free from
                bugs or viruses.
              </li>
              <li>
                You are responsible for configuring your information technology,
                computer programmes and platform in order to access Our Site.
                You should use your own virus protection software.
              </li>
            </ol>
          </li>
          <li>
            <strong>LINKING TO OUR SITE</strong>
            <ol>
              <li>
                You may link to Our home page, provided you do so in a way that
                is fair and legal and does not damage Our reputation or take
                advantage of it.
              </li>
              <li>
                You must not establish a link in such a way as to suggest any
                form of association, approval or endorsement on Our part where
                none exists.
              </li>
              <li>
                You must not establish a link to Our Site in any website that is
                not owned by you.
              </li>
              <li>
                Our site must not be framed on any other site, nor may you
                create a link to any part of Our Site other than the home page.
              </li>
              <li>
                We reserve the right to withdraw linking permission without
                notice.
              </li>
              <li>
                The website in which you are linking must comply in all respects
                with the content standards set out in Our{" "}
                <a href="/terms-and-conditions#acceptable-use-policy">
                  Acceptable Use Policy
                </a>
                .
              </li>
              <li>
                If you wish to make any use of content on Our Site other than
                that set out above, please contact{" "}
                <a href="mailto:info@hammerpricehomes.co.uk">
                  info@hammerpricehomes.co.uk
                </a>
                .
              </li>
            </ol>
          </li>
          <li>
            <strong>THIRD PARTY LINKS AND RESOURCES IN OUR SITE</strong>
            <ol>
              <li>
                Where Our Site contains links to other sites and resources
                provided by third parties, these links are provided for your
                information only.
              </li>
              <li>
                We have no control over the contents of those sites or
                resources.
              </li>
            </ol>
          </li>
          <li>
            <strong>APPLICABLE LAW</strong>
            <ol>
              <li>
                If you are a consumer, please note that these terms of use, its
                subject matter and its formation, are governed by English law.
                You and We both agree to that the courts of England and Wales
                will have non-exclusive jurisdiction. However, if you are a
                resident of Northern Ireland you may also bring proceedings in
                Northern Ireland, and if you are resident of Scotland, you may
                also bring proceedings in Scotland.
              </li>
              <li>
                If you are a business, these terms of use, its subject matter
                and its formation (and any non-contractual disputes or claims)
                are governed by English law. We both agree to the exclusive
                jurisdiction of the courts of England and Wales.
              </li>
            </ol>
          </li>
          <li>
            <strong>IDENTIFYING AND/OR TRADE MARKS</strong>
            <ol>
              <li>
                The Hammer Price Homes logo belongs to Us and the other logos
                used on Our Site are either registered trade marks and/or belong
                to third parties.
              </li>
            </ol>
          </li>
          <li>
            <strong>CONTACT US</strong>
            <ol>
              <li>
                To contact Us, please email{" "}
                <a href="mailto:info@hammerpricehomes.co.uk">
                  info@hammerpricehomes.co.uk{" "}
                </a>
                or call us on <PhoneLink />.
              </li>
            </ol>
          </li>
        </ol>
      </TextContent>
    </div>
  </Layout>
);

export default asPage(TermsOfUse);
